var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { EnumUtilities } from "../../../utilities/enum-utilities";
import { NotificationClientService, NotificationType } from "../../../services/basics/notification-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerbale from "linq";
var Notification = /** @class */ (function () {
    function Notification(notificationService) {
        var _this = this;
        this.notificationModels = [];
        notificationService.subscribeShow(function (model) {
            if (!Enumerbale.from(_this.notificationModels).any(function (x) { return x.title === model.title && x.actionText === model.actionText; })) {
                _this.notificationModels.push(model);
                if (model.time > 0) {
                    setTimeout(function () {
                        _this.close(model);
                    }, model.time);
                }
            }
        });
    }
    Notification.prototype.close = function (model) {
        var _this = this;
        if (this.notificationModels.indexOf(model) < 0) {
            return;
        }
        model.isHidden = true;
        setTimeout(function () {
            _this.notificationModels.splice(_this.notificationModels.indexOf(model), 1);
        }, 300);
    };
    Notification.prototype.performAssignedAction = function (model) {
        if (model.actionHandler)
            model.actionHandler(null);
    };
    Notification.prototype.getEnumName = function (type) {
        var name = EnumUtilities.getName(NotificationType, type);
        return name ? name.toLowerCase() : "";
    };
    Notification = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService])
    ], Notification);
    return Notification;
}());
export { Notification };
